import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { usePermissions } from '../hooks/usePermissions';

interface RoleBasedRouteProps {
  children: React.ReactNode;
  requiredPermission: keyof ReturnType<typeof usePermissions>;
  fallbackPath?: string;
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({
  children,
  requiredPermission,
  fallbackPath = '/dashboard',
}) => {
  const { user, loading } = useContext(AuthContext);
  const permissions = usePermissions();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (!permissions[requiredPermission]) {
    return <Navigate to={fallbackPath} />;
  }

  return <>{children}</>;
};

export default RoleBasedRoute;
